import { FC, useContext, useEffect, useState } from "react";
import { Box, Button, Dialog, Grid, IconButton, Typography } from "@material-ui/core";
import Lottie from "lottie-react";
import { MdClose } from "react-icons/md";
import { useHistory } from "react-router";

import useStyles from "../Styles/ProjectModalStyles";

import AuthContext from "../../store/Auth/AuthContext";

import CryingAnimation from '../../assets/animations/CryingAnimation.json';
import FailedAnimation from '../../assets/animations/Failed.json';
import PendingAnimation from '../../assets/animations/Pending.json';
import UpdateAnimation from '../../assets/animations/UpdateInformation.json';

type KYCErrorModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
}

const KYCErrorModal: FC<any> = ({ open, setOpen }: KYCErrorModalProps) => {

    const classes = useStyles();
    const history = useHistory();

    const { getProfileData } = useContext<any>(AuthContext);

    const [selectedAnimation, setAnimation] = useState<any>();

    useEffect(() => {
        if (getProfileData) {
            if (!getProfileData.kycStatus) setAnimation(CryingAnimation)
            else if (getProfileData.kycStatus === 'rejected') setAnimation(UpdateAnimation)
            else if (getProfileData.kycStatus === 'blocked') setAnimation(FailedAnimation)
            else setAnimation(PendingAnimation)
        }
    }, [getProfileData])

    const handleClose = (event?: React.SyntheticEvent<any, Event>, reason?: string) => {
        if (reason && reason === 'backdropClick') return;
        setOpen(false);
    }

    const handleKyc = () => {
        if (!getProfileData?.kycStatus || getProfileData?.kycStatus === 'rejected')
        history.push('/profile-settings/0')
        else if (getProfileData?.kycStatus === 'blocked') {
          // Redirect to https://t.me/+tIwaCtq58KthMDQ8  
          window.location.href = 'https://t.me/+tIwaCtq58KthMDQ8'
        } else {
            handleClose()
        }
    }

    return (
        <>
            <Box component="section">
                <Dialog
                    open={open}
                    onClose={() => handleClose()}
                    aria-labelledby="kyc-fail"
                    aria-describedby="kyc-fail-modal"
                    disableEscapeKeyDown={false}
                    className={classes.modalpages}
                >
                    <Grid
                        container
                        direction="column"
                        style={{
                            padding: "20px",
                            display: "block"
                        }}
                    >
                        <Grid
                            item
                            justifyContent="flex-end"
                            style={{
                                display: "flex"
                            }}
                        >
                            <IconButton
                                edge="end"
                                color="inherit"
                                aria-label="close"
                                onClick={(event) => handleClose(event, 'buttonClick')}
                            >
                                <MdClose />
                            </IconButton>
                        </Grid>
                        <Grid
                            item
                            lg={12}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "20px",
                            }}
                        >
                            <Lottie animationData={selectedAnimation} style={{
                                width: "180px",
                                height: "auto",
                            }} />
                        </Grid>
                        <Grid 
                            item
                            style={{
                                marginTop: "20px",
                            }}
                        >
                            <Grid
                                container
                                justifyContent="center"
                                lg={12}
                            >
                                <Grid item lg={12}>
                                    <Typography variant="h3" className={classes.progressTitle}>
                                        {
                                            !getProfileData?.kycStatus
                                            ? "Almost There"
                                            : getProfileData?.kycStatus === 'rejected'
                                                ? 'Update Information'
                                                : getProfileData?.kycStatus === 'blocked'
                                                    ? 'An Error Occured'
                                                    : 'Pending Review'
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item lg={9}>
                                    <Typography variant="body1" className={classes.progressMessage}>
                                        {
                                            !getProfileData?.kycStatus
                                            ? "Pass KYC to participate"
                                            : getProfileData?.kycStatus === 'rejected'
                                                ? 'Please redo the KYC, some provided details are incomplete/incorrect'
                                                : getProfileData?.kycStatus === 'blocked'
                                                    ? 'Please reach out to our support team for an additional review of your KYC'
                                                    : 'KYC under review, you will receive an email soon with an update'
                                        }
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid 
                            item
                            style={{
                                marginTop: "40px",
                                justifyContent: "center",
                                display: "flex",
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    background: "#3EB8AA",
                                    width: "90%",
                                    height: "48px",
                                }}
                                onClick={handleKyc}
                            >
                                {
                                            !getProfileData?.kycStatus
                                            ? "Pass KYC"
                                            : getProfileData?.kycStatus === 'rejected'
                                                ? 'Redo KYC'
                                                : getProfileData?.kycStatus === 'blocked'
                                                    ? 'Contact Support'
                                                    : 'Understood'
                                        }
                            </Button>
                        </Grid>
                    </Grid>
                </Dialog>
            </Box>
        </>
    )
}

export default KYCErrorModal;